(function () {
  var root = document.querySelector('[data-pack-builder]');
  if (!root) return;

  var data;
  try { data = JSON.parse(root.querySelector('[data-pack-data]').textContent); } catch (e) { return; }
  var products = data.products || [];
  var fixed = parseInt(root.dataset.fixedSize, 10) || 0;
  var fixedCents = parseInt(root.dataset.priceCents, 10) || 0;
  var prices = { 3: parseFloat(root.dataset.price3) || 800, 4: parseFloat(root.dataset.price4) || 1000 };
  var SIZE_RE = /size|المقاس|مقاس/i;

  var q = function (s) { return root.querySelector(s); };
  var els = {
    sizesWrap: q('[data-sizes-wrap]'), sizes: q('[data-sizes]'),
    designs: q('[data-designs]'), picked: q('[data-picked]'), options: q('[data-options]'),
    qty: q('[data-qty]'), minus: q('[data-qty-minus]'), plus: q('[data-qty-plus]'),
    addPack: q('[data-add-to-pack]'), msg: q('[data-msg]'),
    slots: q('[data-slots]'), count: q('[data-count]'),
    buy: q('[data-add-to-cart]'), total: q('[data-total]'), tabs: root.querySelectorAll('[data-pack-size]')
  };

  var state = { size: fixed || 3, sizeVal: null, product: null, sel: [], qty: 1, slots: [] };

  function sizeIdx(p) {
    for (var i = 0; i < p.options.length; i++) if (SIZE_RE.test(p.options[i].name)) return i;
    return -1;
  }
  var allSizes = [];
  products.forEach(function (p) {
    var i = sizeIdx(p);
    if (i < 0) return;
    p.options[i].values.forEach(function (v) { if (allSizes.indexOf(v) < 0) allSizes.push(v); });
  });

  function money(units) {
    var cents = Math.round(units);
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    function group(v, dec, th, dot) {
      var parts = (v / 100).toFixed(dec).split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return parts[1] ? whole + dot + parts[1] : whole;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return group(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(cents, 0, '.', ',');
      return group(cents, 2, ',', '.');
    });
  }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function packCents() { return fixed ? fixedCents : prices[state.size] * 100; }

  function variantFor(p, sel) {
    return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
  }
  function inPack(id) { return state.slots.filter(function (s) { return s.variant.id === id; }).length; }
  function availInSize(p) {
    var i = sizeIdx(p);
    return p.variants.some(function (v) { return v.available && (i < 0 || !state.sizeVal || v.options[i] === state.sizeVal); });
  }
  function anyAvailable(p) { return p.variants.some(function (v) { return v.available; }); }

  // Show the chosen design in the product gallery (first photo of the page)
  function showPreview(p) {
    var viewer = document.querySelector('[data-media-gallery] .product-media-gallery__viewer');
    if (!viewer || !p || !p.imageLarge) return;
    var slide = viewer.querySelector('[data-pack-preview]');
    if (!slide) {
      slide = document.createElement('div');
      slide.className = 'product-media-gallery__slide';
      slide.setAttribute('data-media-slide', '');
      slide.setAttribute('data-pack-preview', '');
      viewer.insertBefore(slide, viewer.firstChild);
    }
    slide.style.setProperty('--slide-ratio', p.ratio || 0.8);
    slide.innerHTML = '<img class="product-media-gallery__image" src="' + esc(p.imageLarge) + '" alt="' + esc(p.title) + '" width="1200">';
    if (window.matchMedia('(max-width: 1099px)').matches) {
      viewer.scrollTo({ left: 0, behavior: 'smooth' });
      slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    } else {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slide.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
  }

  function selectProduct(p) {
    state.product = p;
    var i = sizeIdx(p);
    var pool = p.variants.filter(function (v) { return v.available && (i < 0 || !state.sizeVal || v.options[i] === state.sizeVal); });
    var v = pool[0] || p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    state.sel = v ? v.options.slice() : p.options.map(function (o) { return o.values[0]; });
    if (i >= 0 && state.sizeVal) state.sel[i] = state.sizeVal;
    state.qty = 1;
  }

  function valueAvailable(p, optIndex, value) {
    return p.variants.some(function (v) {
      if (!v.available || v.options[optIndex] !== value) return false;
      return v.options.every(function (o, j) { return j === optIndex || o === state.sel[j]; });
    });
  }

  function setMsg(t) { els.msg.textContent = t || ''; }

  function renderSizes() {
    if (!els.sizesWrap) return;
    if (!allSizes.length) { els.sizesWrap.hidden = true; return; }
    els.sizesWrap.hidden = false;
    els.sizes.innerHTML = allSizes.map(function (v) {
      var on = state.sizeVal === v;
      var ok = products.some(function (p) { var i = sizeIdx(p); return p.variants.some(function (x) { return x.available && x.options[i] === v; }); });
      return '<button type="button" class="pb__size' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" aria-pressed="' + on + '" data-size-val="' + esc(v) + '">' + esc(v) + '</button>';
    }).join('');
  }

  function renderDesigns() {
    els.designs.innerHTML = products.map(function (p) {
      var on = state.product && state.product.id === p.id;
      var ok = availInSize(p);
      return '<button type="button" class="pb__design' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" role="radio" aria-checked="' + on + '" data-design="' + p.id + '" aria-label="' + esc(p.title) + (ok ? '' : ', sold out in this size') + '">' +
        (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="66" height="66">' : '') + '</button>';
    }).join('');
    var p = state.product;
    els.picked.innerHTML = p ? '<p class="pb__name">' + esc(p.title) + '</p>' + (p.type ? '<p class="pb__type">' + esc(p.type) + '</p>' : '') : '';
  }

  function renderOptions() {
    var p = state.product;
    if (!p) { els.options.innerHTML = ''; return; }
    var si = sizeIdx(p);
    els.options.innerHTML = p.options.map(function (o, i) {
      if (i === si || o.values.length < 2) return '';
      return '<fieldset class="pb__opt"><legend>' + esc(o.name) + ' <span>' + esc(state.sel[i]) + '</span></legend><div class="pb__chips">' +
        o.values.map(function (v) {
          var on = state.sel[i] === v;
          var ok = valueAvailable(p, i, v);
          return '<button type="button" class="pb__chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" aria-pressed="' + on + '" data-opt="' + i + '" data-val="' + esc(v) + '">' + esc(v) + '</button>';
        }).join('') + '</div></fieldset>';
    }).join('');
  }

  function renderSlots() {
    var html = '';
    for (var i = 0; i < state.size; i++) {
      var s = state.slots[i];
      if (s) {
        var label = s.product.title + ' ' + s.variant.options.join(' / ');
        html += '<li><button type="button" class="pb__slot is-filled" data-remove="' + i + '" aria-label="Remove ' + esc(label) + '">' +
          (s.product.image ? '<img src="' + esc(s.product.image) + '" alt="" width="100" height="100">' : '') +
          '<span class="pb__slot-x" aria-hidden="true">&times;</span></button><p class="pb__slot-cap">' + esc(s.variant.options.filter(function (o) { return o !== 'Default Title'; }).join(' / ')) + '</p></li>';
      } else {
        html += '<li><span class="pb__slot" aria-hidden="true"></span><p class="pb__slot-cap">&nbsp;</p></li>';
      }
    }
    els.slots.innerHTML = html;
    els.count.textContent = state.slots.length + ' / ' + state.size;
  }

  function refresh() {
    var p = state.product;
    var v = p ? variantFor(p, state.sel) : null;
    var remaining = state.size - state.slots.length;
    var left = v ? Math.max(0, v.max - inPack(v.id)) : 0;
    var cap = Math.max(0, Math.min(remaining, left));
    if (state.qty > cap && cap > 0) state.qty = cap;
    if (state.qty < 1) state.qty = 1;
    els.qty.textContent = state.qty;
    els.minus.disabled = state.qty <= 1;
    els.plus.disabled = state.qty >= cap;
    var needSize = allSizes.length > 0 && !state.sizeVal;
    els.addPack.disabled = needSize || !(v && v.available && cap >= state.qty && cap > 0);
    if (needSize) setMsg('Choose a size first');
    else if (!v || !v.available) setMsg(p && !anyAvailable(p) ? 'Sold out' : (state.sizeVal ? 'Sold out in size ' + state.sizeVal : 'This combination is sold out'));
    else if (remaining === 0) setMsg('Your pack is full');
    else if (left === 0) setMsg('You have added all that is in stock');
    else if (!els.msg.dataset.keep) setMsg('');
    var packOut = root.dataset.packAvailable === 'false';
    els.buy.disabled = packOut || state.slots.length !== state.size;
    var outEl = root.querySelector('[data-pack-out]'); if (outEl) outEl.hidden = !packOut;
    els.total.textContent = money(packCents());
    renderSizes(); renderSlots(); renderOptions(); renderDesigns();
  }

  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-pack-size]'))) {
      state.size = parseInt(t.dataset.packSize, 10);
      els.tabs.forEach(function (b) { var on = b === t; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      if (state.slots.length > state.size) state.slots = state.slots.slice(0, state.size);
      refresh(); return;
    }
    if ((t = e.target.closest('[data-size-val]'))) {
      state.sizeVal = t.dataset.sizeVal;
      if (state.product) { var si = sizeIdx(state.product); if (si >= 0) state.sel[si] = state.sizeVal; }
      state.qty = 1; refresh(); return;
    }
    if ((t = e.target.closest('[data-design]'))) {
      var p = products.filter(function (x) { return String(x.id) === t.dataset.design; })[0];
      if (p) { selectProduct(p); refresh(); showPreview(p); }
      return;
    }
    if ((t = e.target.closest('[data-opt]'))) { state.sel[parseInt(t.dataset.opt, 10)] = t.dataset.val; state.qty = 1; refresh(); return; }
    if (e.target.closest('[data-qty-minus]')) { state.qty = Math.max(1, state.qty - 1); refresh(); return; }
    if (e.target.closest('[data-qty-plus]')) { state.qty += 1; refresh(); return; }
    if (e.target.closest('[data-add-to-pack]')) {
      var v = variantFor(state.product, state.sel);
      if (!v) return;
      for (var i = 0; i < state.qty; i++) state.slots.push({ product: state.product, variant: v });
      state.qty = 1; refresh();
      setMsg(state.slots.length === state.size ? 'Your pack is full. Add it to your cart.' : state.slots.length + ' of ' + state.size + ' selected');
      return;
    }
    if ((t = e.target.closest('[data-remove]'))) { state.slots.splice(parseInt(t.dataset.remove, 10), 1); refresh(); return; }
    if (e.target.closest('[data-add-to-cart]')) addToCart();
  });

  function addToCart() {
    if (state.slots.length !== state.size) return;
    var variantId = parseInt(root.dataset.packVariant, 10);
    if (!variantId) { setMsg('This pack is not set up yet.'); return; }
    var label = 'Pack of ' + state.size;
    var props = { _pack: label };
    state.slots.forEach(function (s, i) {
      var opts = s.variant.options.filter(function (o) { return o !== 'Default Title'; }).join(' / ');
      props['Item ' + (i + 1)] = s.product.title + (opts ? ' (' + opts + ')' : '');
      if (s.product.image) props['_Img ' + (i + 1)] = s.product.image;
    });
    els.buy.disabled = true; els.buy.setAttribute('aria-busy', 'true');
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(rootPath + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { state.slots = []; refresh(); setMsg('Added to your bag'); document.dispatchEvent(new CustomEvent('cart:open')); })
      .catch(function (err) { setMsg((err && (err.description || err.message)) || 'Could not add this pack. Please try again.'); els.buy.disabled = state.slots.length !== state.size; })
      .then(function () { els.buy.removeAttribute('aria-busy'); });
  }

  if (products[0]) selectProduct(products[0]);
  refresh();
})();
